import { AsyncMultiComboBox, type ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import { getCustomers, type GetCustomersParams } from '../../api/clients/company.api';
import { queries } from '../../api/queryKeys/queries';
import { formatCompanyName } from '../../helpers/formatCompanyName.helper';
import type { AsyncMultiSelectProps } from '../AsyncSelectProps';

export interface CustomerCompanyMultiSelectProps extends AsyncMultiSelectProps {
    onChange: (customerIds: string[]) => void;
    groupId?: string;
    value: string[];
}

const loadCustomers = async (params: GetCustomersParams): Promise<ComboBoxOption[]> => {
    const customers = await getCustomers(params);

    return customers.map((company) => ({
        value: company.id,
        label: formatCompanyName({
            company,
        }) as ComboBoxOption['label'],
    }));
};

export function CustomerCompanyMultiSelect({ groupId, value, onChange, ...rest }: CustomerCompanyMultiSelectProps) {
    return (
        <AsyncMultiComboBox
            {...rest}
            value={value}
            onChange={onChange}
            optionsQueryKey={(search) => queries.customers.comboBoxOptions({ searchQuery: search, groupId }).queryKey}
            optionsQueryFn={(search) => loadCustomers({ searchQuery: search, groupId })}
            selectedOptionsQueryKey={(values) => queries.customers.comboBoxOptions({ ids: values }).queryKey}
            selectedOptionsQueryFn={(values) => loadCustomers({ ids: values })}
        />
    );
}
